import './Footer.css';
import React, {useContext} from 'react';
import ReactDOM from 'react-dom';
import { AppContext } from '../AppContext';
import {useNavigate} from "react-router-dom";

class Footer extends React.Component {
    constructor(props) {
        super(props);
    }

    get newsHost() {
        return document.querySelector('footer ul.Latest-News-List');
    }

    get videoHost() {
        return document.querySelector('footer ul.Latest-Videos-List');
    }

    openLink(e, news_article) {
        e.preventDefault();
        this.props.navigate(news_article.link);
        window.scrollTo(0, 0); // Scroll to top
    }

    getLatestVideosList() {
        if (!this.props.context?.components?.videos || !(this.props.context.components.videos.length > 0)) {
            return (
                <>
                    <li><span className="skeleton VideoPlaceHolder" aria-hidden="true"></span></li>
                    <li><span className="skeleton VideoPlaceHolder" aria-hidden="true"></span></li>
                    <li><span className="skeleton VideoPlaceHolder" aria-hidden="true"></span></li>
                    <li><span className="skeleton VideoPlaceHolder" aria-hidden="true"></span></li>
                    <li><span className="skeleton VideoPlaceHolder" aria-hidden="true"></span></li>
                    <li><span className="skeleton VideoPlaceHolder" aria-hidden="true"></span></li>
                </>
            );
        }
        let video_elements = [];
        for (let video of this.props.context?.components?.videos) {
            if (video_elements.length === 6) {
                // Show only five of latest new headlines in footer
                break;
            }
            video_elements.push((
                <>
                    <li>
                        <a href={'https://youtu.be/' + video.id} target="_blank"><img src={video.thumbnail} fetchpriority="low" width={video.thumbnail_width} height={video.thumbnail_height} alt={video.title} title={video.title} /></a>
                    </li>
                </>
            ));
        }
        return video_elements;
    }

    getLatestNewsList() {
        if (!this.props.context?.components?.news || !(this.props.context.components.news.length > 0)) {
            return (
                <>
                    <li><span className="skeleton" aria-hidden="true"></span></li>
                    <li><span className="skeleton" aria-hidden="true"></span></li>
                    <li><span className="skeleton" aria-hidden="true"></span></li>
                    <li><span className="skeleton" aria-hidden="true"></span></li>
                    <li><span className="skeleton" aria-hidden="true"></span></li>
                </>
            );
        }
        let news_elements = [];
        for (let news of this.props.context?.components?.news) {
            if (news_elements.length === 5) {
                // Show only five of latest new headlines in footer
                break;
            }
            news_elements.push((
                <>
                    <li>
                        <a href={news.link} onClick={(e) => { this.openLink(e, news); }}>{news.topic}</a>
                    </li>
                </>
            ));
        }
        return news_elements;
    }

    render() {
        if (!this.newsHost || !this.videoHost) {
            return null;
        }
        if (this.newsHost.classList.contains('IsLoading')) {
            this.newsHost.replaceChildren();
            this.newsHost.classList.remove('IsLoading');
            this.videoHost.replaceChildren();
            this.videoHost.classList.remove('IsLoading');
        }
        const newsPortal = ReactDOM.createPortal(this.getLatestNewsList(), this.newsHost);
        const videoPortal = ReactDOM.createPortal(this.getLatestVideosList(), this.videoHost);
        return (
            <>
                {newsPortal}
                {videoPortal}
            </>
        );
    }
}

const FooterWithContext = (props) => {
    const navigate = useNavigate();
    const context = useContext(AppContext);
    return (<Footer {...props} context={context} navigate={navigate} />);
};

export default FooterWithContext;
